import { createSlice } from '@reduxjs/toolkit';

import type { AppState } from '../index';

/**
 * 全局 ui 控制
 *
 */

// slice state 类型定义
interface AuthenticationState {
  /**
   * 是否进入等候室
   * 1. 进会的时候进入等候室
   * 2. 在会议中的时候被主持人移到等候室
   */
  ifShowWaitingRoom: boolean;

  /* 是否展示参会成员列表 */
  ifShowAttendee: boolean;

  /* 是否展示小视频列表 */
  ifShowSmallList: boolean;

  /*
   * 沉浸模式
   * 是否隐藏头部/底部
   */
  immersiveMode: boolean;

  /**
   * 是否展示邀请弹框
   */
  ifShowInviteDialog: boolean;
  /**
   * 是否展示主持人下载提醒
   */
  ifShowHostTips: boolean;
  /**
   * @description 是否显示手机号校验
   */
  ifShowMobileVerify: boolean;
  /**
   * @description 是否展示合规
   */
  ifShowAgreement: boolean;
  /**
   * @description 展示免费时长倒计时
   */
  ifShowFreeTime: boolean;
  /**
   * @description 免费倒计时时间
   */
  remainTime: number;
}

// 初始状态
const initialState: AuthenticationState = {
  ifShowWaitingRoom: false,

  ifShowAttendee: false,

  immersiveMode: false,

  ifShowInviteDialog: false,

  ifShowHostTips: false,

  ifShowSmallList: true,

  ifShowMobileVerify: false,

  ifShowAgreement: false,

  ifShowFreeTime: false,

  remainTime: 0,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    showAttendee: (state) => {
      state.ifShowAttendee = true;
    },
    hideAttendee: (state) => {
      state.ifShowAttendee = false;
    },
    showWaitingRoom: (state) => {
      state.ifShowWaitingRoom = true;
    },
    hideWaitingRoom: (state) => {
      state.ifShowWaitingRoom = false;
    },
    changeIfShowInviteDialog: (state, action) => {
      state.ifShowInviteDialog = action.payload;
    },
    changeIfShowHostTips: (state, action) => {
      state.ifShowHostTips = action.payload;
    },
    changeIfShowSmallList: (state, action) => {
      state.ifShowSmallList = action.payload;
    },
    changeIfShowMobileVerify: (state, action) => {
      state.ifShowMobileVerify = action.payload;
    },
    changeIfShowAgreement: (state, action) => {
      state.ifShowAgreement = action.payload;
    },
    changeIfShowFreeTime: (state, action) => {
      state.ifShowFreeTime = action.payload;
    },
    changeRemainTime: (state, action) => {
      state.remainTime = action.payload;
    },
  },
});

export const {
  showAttendee,
  hideAttendee,
  showWaitingRoom,
  hideWaitingRoom,
  changeIfShowInviteDialog,
  changeIfShowHostTips,
  changeIfShowSmallList,
  changeIfShowAgreement,
  changeIfShowMobileVerify,
  changeIfShowFreeTime,
  changeRemainTime,
} = uiSlice.actions;

export const getIfShowAttendee = (state: AppState) => state.ui.ifShowAttendee;
export const getIfShowWaitingRoom = (state: AppState) => state.ui.ifShowWaitingRoom;
export const getIfShowInviteDialog = (state: AppState) => state.ui.ifShowInviteDialog;
export const getIfShowHostTips = (state: AppState) => state.ui.ifShowHostTips;
export const getIfShowSmallList = (state: AppState) => state.ui.ifShowSmallList;
export const getIfShowMobileVerify = (state: AppState) => state.ui.ifShowMobileVerify;
export const getIfShowAgreement = (state: AppState) => state.ui.ifShowAgreement;
export const getIfShowFreeTime = (state: AppState) => state.ui.ifShowFreeTime;
export const getRemainTime = (state: AppState) => state.ui.remainTime;

export default uiSlice.reducer;
